import React from 'react';
import { useFlag } from '@unleash/proxy-client-react';

import { AppToggle } from '../../clients/unleash/app-toggle-names';
import { Status } from '../Status/Status';

import { MessageList } from './MessageList/MessageList';
import { ConversationsProvider } from './ConversationsContext';
import { PortBoundary } from './PortBoundary';

import styles from './Chat.module.scss';

export const Chat: React.FC = () => {
    const chatTabFiltersEnabled = useFlag(AppToggle.CHAT_TAB_FILTERS);

    return (
        <div className={styles.container}>
            <div className={styles.status}>
                <Status displaySourceList={chatTabFiltersEnabled} />
            </div>
            <PortBoundary>
                <ConversationsProvider>
                    <MessageList />
                </ConversationsProvider>
            </PortBoundary>
        </div>
    );
};
